/* eslint-disable no-nested-ternary */
import React, { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Image from 'components/Image';
import ImageV2 from 'components_v2/common/ImageV2';
import RelatedStoriesCardBottom from 'components_v2/mobile/RelatedStoriesCardBottom/RelatedStoriesCardBottom';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { getImageFromImageObject } from 'components/Image/utils';
import LinkV1 from 'components/Link';
import LinkV2 from 'components/Link/LinkV2';
import { convertHtmlToStringText } from 'utils/common';
import LeadLiveIcon from 'components_v2/common/LeadLiveIcon/LeadLiveIcon';
import classNames from 'classnames';
import { UseIntersectionObeserver } from 'routes/home/layouts/India/context';
import useGrxIntersection from 'components_library/utils/grxUtil/grxIntersectionObserver';
import AdCaller from 'helpers/ads/adCaller';
import Icon from './Icon';
import CardBottom from './CardBottom';
import s from './Card.scss';
import { PRC_FOR_FTU, PRC_FOR_SUBSCRIBED } from '../../../constants';
import {
  triggerGrxListClick,
  triggerGrxListView,
} from '../../../components_library/utils/grxUtil/grxPayloadUtil';
import PopupOverlay from '../PopupOverlay/PopupOverlay';

function customOnError(e) {
  e.target.onerror = null;
  e.target.src = 'https://static.toiimg.com/photo/25581306.cms';
}

function getGAVal(gaData, data) {
  if (typeof gaData !== 'string' || !gaData) {
    return '';
  }

  let type = 'Article';
  if (
    data.hasVideo ||
    data.hasvideo ||
    data.type === 'video' ||
    data.tn === 'video'
  ) {
    type = 'Video';
  } else if (data.type === 'photostory' || data.tn === 'photostory') {
    type = 'Photo';
  }
  return gaData.replace('$type', type);
}

function Card(props) {
  const {
    isLeadImageNews,
    data = {},
    showDescription,
    showDuration,
    showPhotosCount,
    onClick,
    itemClass,
    linkData,
    htmlKeys,
    shouldNotlazyloadImage,
    imgFit,
    cssObj: { figureClass = '', imgCont = '', titleCont = '', desc = '' } = {},
    isInlineSmallIconCard,
    topicPage,
    isWapView,
    tpPageName,
    index,
    hideDescription,
    useImageV2,
    isMobile,
    timesassistCard,
    timesassistLeadCard,
    sportsImagewidth,
    resizeMode,
    noImage,
    isNoLink,
    noLinkClass,
    imgHeight,
    addFetchPriorityHighAttribute,
    useLinkV2,
    stpPrpgtnAndPrvDflt,
    slikeId,
    setSlikePreviewId,
    enableRelatedStoriesSupport,
  } = props;

  const Link = useLinkV2 ? LinkV2 : LinkV1;

  const { imgWidth = isMobile ? '375' : '600' } = props;
  const { imageid = '', imagesize = '123456', du: duration, imageUrl } = data;
  const useIntersectionObeserver = useContext(UseIntersectionObeserver);
  const ImageElement = useIntersectionObeserver || useImageV2 ? ImageV2 : Image;
  const [hoveredSlikeId, sethoveredSlikeId] = useState(false);
  const [showBannerPopup, setShowBannerPopup] = useState(false);
  const [bannerPopup, setBannerPopup] = useState(null);
  const photosCount = data.photosCount || data.imgcount;
  const { image = {} } = data;
  const { campaignBgColor, campaignTxtColor } = data;
  image.width = sportsImagewidth
    ? '250'
    : isInlineSmallIconCard ? '160' : imgWidth;
  image.width =
    data.relatedStories &&
    Array.isArray(data.relatedStories) &&
    data.relatedStories.length > 0
      ? '375'
      : image.width;
  image.id = imageid || image.id;
  image.version = imagesize || image.version;
  if (resizeMode && resizeMode !== '') {
    image.resizemode = resizeMode;
  }
  if (imgHeight && imgHeight !== '') {
    image.height = imgHeight;
  }
  const { titlePrefix = '' } = data;
  const imageSrc = getImageFromImageObject(image, isMobile) || imageUrl;

  const {
    isLeadTypeTwo, //lead for City, Business
    isLeadVideo,
    showSectionName,
    isMobileInlineVideo,
    // isInlineSmallIconCard,
    isLeadPhoto,
    isVerticalTile,
    isPhotoWidget, // for Desktop "photo" widget only
    isVideoWidget, // for Desktop "Videos" widget only
    timeStampHtml,
    plusIconNotRequired,
    target,
    isPhotoVisualStory,
    isMoreStoriesListingCard,
    viewga,
    isPaperStoryText,
    payPerTxt,
    istoipListing,
    cardClass,
    gaPageName,
    userData,
    isVertical,
    isTopWidget,
    isHomeListing,
    isLongCard,
    toiPCardTheme,
    isMostAnalytics,
    priceTag,
    paidStoriesMsid,
    isExplainerListingCard,
    showBottomDescription,
    showCategory,
    topicNewsPage,
    showDate,
    hideInnerIntrinsicSize,
    ga4Type,
    ga4Category,
    gaIndex,
    isCtnCpd,
    showPopup,
  } = props;
  const isLoggedIn =
    userData && userData.isLoggedIn ? userData.isLoggedIn : false;
  const prcValue = userData && userData.prcValue ? userData.prcValue : 0;
  const toiPlusGAEvent = gaLabel => {
    if (typeof window !== 'undefined') {
      analyticsWrapper(
        'ga',
        'send',
        'event',
        'TOI Plus',
        gaLabel,
        `Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`,
      );
    }
  };
  const handleTouchStart = id => {
    // setSlikePreviewId(id, gaIndex);
    if (typeof setSlikePreviewId === 'function') {
      setSlikePreviewId(id, gaIndex);
    } else {
      console.log('setSlikePreviewId is not a function');
    }
  };
  const topStoryCardRef = useRef();

  useEffect(() => {
    if (props.isFirstHPassistStory) {
      setTimeout(() => {
        const bodystruct = {
          version: '04Jul2023',
          type: 'redirect',
          l_bot_shown: data && data.botname && data.botname.toLowerCase(),
        };
        analyticsWrapper('grx', 'track', 'TOIAssist_WidgetView', {
          slot_name: 'toi_hp_5thstory',
          body: JSON.stringify(bodystruct),
        });
      }, 5000);
    }
  }, []);
  if (isWapView) {
    useGrxIntersection(topStoryCardRef, () => {
      if (ga4Type === 'top_stories') {
        triggerGrxListView({
          storyNo: gaIndex,
          msidViewed: data?.id ? data.id : '',
        });
      }
    });
  }
  const triggerGrxclick = () => {
    if (ga4Type === 'top_stories' && isWapView) {
      triggerGrxListClick({
        storyNo: gaIndex,
        msidViewed: data?.id ? data.id : '',
      });
    }
  };
  const gaOnLabelClick = sec => {
    let labelName = '';
    if (sec?.type && sec.type === 'noc') {
      labelName += 'TOIPlus_NOCLabel';
    } else if (sec?.type && sec.type === 'section') {
      labelName += 'TOIPlus_sectionStoryLabel';
    } else if (
      sec?.type &&
      (sec.type === 'taxonomy' || sec.type === 'taxonomy_sub_topic')
    ) {
      labelName += `TOIPlus_Taxonomy_${sec?.topicTree}`;
    }
    if (
      sec?.type &&
      (sec.type === 'taxonomy' || sec.type === 'taxonomy_sub_topic')
    ) {
      toiPlusGAEvent(`${labelName}_click`);
    } else {
      toiPlusGAEvent(`${labelName}_${sec.name}_click`);
    }
  };
  const showPriceTag =
    userData &&
    Object.keys(userData).length !== 0 &&
    prcValue !== PRC_FOR_FTU &&
    prcValue !== PRC_FOR_SUBSCRIBED &&
    data.isLead &&
    !paidStoriesMsid.includes(data.id);
  const isTypeVideo =
    data.hasVideo ||
    data.hasvideo ||
    data.type === 'video' ||
    data.tn === 'video' ||
    isMobileInlineVideo;
  const isTypeAd = data.tn === 'ad';
  const isPhotoStory = data.type === 'photostory' || data.tn === 'photostory';
  const isToiPlusStory = data.cs === 'prime';
  const isTOIPLeadImage = !!data.isLead && istoipListing;
  const isIconNeeded =
    isPhotoStory || isTypeVideo || isToiPlusStory || showPriceTag;
  const figureClassName = classNames({
    [s.card]: true,
    [s.leadthumb]:
      isLeadImageNews || isLeadVideo || isLeadPhoto || isLeadTypeTwo,
    [s.Smallleadthumb]: isLeadTypeTwo,
    [s.mediathumb]: isVerticalTile || isPhotoWidget,
    [s.photoWidget]: isPhotoWidget,
    [s.videoWidget]: isVideoWidget,
    [s.photoStory]: isPhotoVisualStory,
    [s.topicNewsListingThumb]: topicNewsPage,
    [s.videomediathumb]: isMobileInlineVideo && isVerticalTile,
    [s.cardwithoutthumb]: cardClass === 'cardwithoutthumb' && !isVerticalTile,
    [s.no_bdr_last]: cardClass === 'cardwithoutthumb' && !isVerticalTile,
    [s.mediathumbwithmargin]:
      cardClass === 'withoutlead4list' && isVerticalTile,
    timesassist_card: timesassistCard,
  });
  const contentVisibilityClass = classNames({
    [s.card_intrinsic_size]: isInlineSmallIconCard,
    [s.video_card_intrinsic_size]: isMobileInlineVideo && isVerticalTile,
    [s.leadthumb_intrinsic_size]:
      isLeadImageNews || isLeadVideo || isLeadPhoto || isLeadTypeTwo,
  });
  const cardInner = classNames({
    [s.cardwrapper]: true,
    [s.txtwothumb]: cardClass === 'cardwithoutthumb' && !isVerticalTile,
    [s.inner_intrinsic_size]: !hideInnerIntrinsicSize,
  });

  let leadPhotostoryVideoClass = '';
  if (isLeadImageNews && (isTypeVideo || isPhotoStory)) {
    leadPhotostoryVideoClass = 'leadPhotostoryVideoClass';
  }

  let titleContainerClass;
  if (isLeadTypeTwo || isLeadImageNews) {
    titleContainerClass = s.headingwithicon;
  } else if (isLeadVideo || isPhotoWidget) {
    titleContainerClass = s.titleWithIcon;
  }

  let headingTxt = data.hl || data.name;
  if (htmlKeys && htmlKeys instanceof Array && htmlKeys.indexOf('hl') > -1) {
    headingTxt = convertHtmlToStringText(data.hl || data.name);
  }

  let descTxt = data.des || data.syn;
  if (htmlKeys && htmlKeys instanceof Array && htmlKeys.indexOf('des') > -1) {
    descTxt = convertHtmlToStringText(data.des || data.syn);
  }
  descTxt = descTxt || '';
  const shouldShowDescription =
    showDescription && typeof descTxt === 'string' && descTxt !== '';
  const shouldShowBottomDescription =
    showBottomDescription && typeof descTxt === 'string' && descTxt !== '';
  let _target = target ? '_blank' : '';

  const showRelatedStories =
    Array.isArray(data.relatedStories) &&
    data.relatedStories?.length > 0 &&
    tpPageName === 'toiphome';

  if (data.target && data.target === '_blank') {
    _target = data.target;
  }

  const handleClosePopup = () => {
    setShowBannerPopup(false);
  };

  const handleBannerClick = banner => {
    setShowBannerPopup(true);
    setBannerPopup(banner);
  };

  const renderPopupImage = () => (
    <PopupOverlay
      position="center"
      closeCallback={handleClosePopup}
      show={showBannerPopup}
      blackOverlayEnabled
    >
      <Image
        msid={bannerPopup.id}
        resizemode={4}
        imgsize={bannerPopup.imagesize}
        //width="620"
        alt={bannerPopup.hl}
        title={bannerPopup.title || ''}
        placeHolderSrc="https://static.toiimg.com/photo/83033472.cms"
      />
    </PopupOverlay>
  );

  const renderMoreStoriesCard = () => (
    <div>
      <figcaption
        className={`${titleCont} ${timeStampHtml ? 'is_timestamp' : ''} ${
          data.tn === 'liveblog' ? s.lbBlinker : ''
        }`}
      >
        {timeStampHtml ? (
          topicPage ? (
            <span
              className={`${s.searchTitle}`}
              dangerouslySetInnerHTML={{
                __html: `<span> ${headingTxt} </span>`,
              }}
            />
          ) : (
            <span>{headingTxt}</span>
          )
        ) : topicPage ? (
          <span
            className={`${s.searchTitle}`}
            dangerouslySetInnerHTML={{
              __html: `<span> ${headingTxt} </span>`,
            }}
          />
        ) : (
          <span>
            <>
              <>{headingTxt}</>
              {data.tn === 'liveblog' ? (
                <span className={`${s.liveBtn} ${s.red}`} />
              ) : null}
            </>
          </span>
        )}
        {timeStampHtml && <p>{timeStampHtml}</p>}
      </figcaption>
    </div>
  );

  const renderConditionalCard = txtColor => (
    <>
      {props.restProps && props.restProps.showSecName && data.secname !== '' ? (
        <div className={s.city_section_name}>{data.secname}</div>
      ) : null}
      <figcaption
        style={{ color: txtColor }}
        className={`${titleCont} ${timeStampHtml ? 'is_timestamp' : ''} ${
          data.tn === 'liveblog' ? s.lbBlinker : ''
        } ${showCategory ? s.categoryClamp : ''} ${
          timesassistLeadCard ? s.timesAssistCard : ''
        }`}
      >
        {data.tn === 'liveblog' ? (
          <div className={`${s.liveBtn} ${s.red}`} />
        ) : null}

        {/* <div className={`${s.liveBtn} ${s.red}`} /> */}
        {/* {titlePrefix && (
                <span className="toiPlusTag">{titlePrefix}:</span>
              )} */}
        {((showCategory && data.secname) || (showDate && data.dl)) && (
          <div className={s.data_meta}>
            {showCategory &&
              data.secname && (
                <span className={`${s.card_category} ${s.secname}`}>
                  {data.secname}
                </span>
              )}
            {showDate &&
              data.dl && (
                <span className={`${s.dateformat}`}>{`${
                  showCategory && data.secname ? '/ ' : ''
                }${data.dl}`}</span>
              )}
          </div>
        )}
        {timeStampHtml ? (
          topicPage ? (
            <span
              className={`${s.searchTitle}`}
              dangerouslySetInnerHTML={{
                __html: `<span> ${headingTxt} </span>`,
              }}
            />
          ) : (
            <span>{headingTxt}</span>
          )
        ) : topicPage ? (
          <span
            className={`${s.searchTitle}`}
            dangerouslySetInnerHTML={{
              __html: `<span> ${headingTxt} </span>`,
            }}
          />
        ) : (
          <>
            {timesassistLeadCard ? (
              <span>
                {headingTxt}
                {data.slug && <sup className="newLabel">{data.slug}</sup>}
              </span>
            ) : (
              <>{headingTxt}</>
            )}
          </>
        )}
        {timesassistCard &&
          data.slug && <sup className="newLabel">{data.slug}</sup>}
        {timeStampHtml && <p>{timeStampHtml}</p>}
        {timesassistLeadCard &&
          data.ctaText && (
            <div className="timesassistCaption">
              {data.ctaText}
              {data.toiPlusLogo && <i className="timesAssistPlusIcon" />}
            </div>
          )}
      </figcaption>
      {shouldShowDescription &&
        descTxt &&
        descTxt !== 'null' && <p className={`${desc}`}>{descTxt}</p>}
    </>
  );

  const toipCardCategory = () => {
    if (tpPageName === 'taxonomyListing') {
      const modifidCategories = [];
      if (
        data &&
        data.category &&
        Array.isArray(data.category) &&
        data.category.length > 0
      ) {
        data.category.forEach(category => {
          if (category?.type === 'taxonomy') {
            modifidCategories[0] = category;
          }
          if (category?.type === 'noc') {
            modifidCategories[1] = category;
          }
        });
      }
      data.category = modifidCategories;
    }

    return (
      <div className={s.card_category}>
        {Array.isArray(data?.category) &&
          data?.category.map(
            (sec, i) =>
              sec.type !== tpPageName &&
              (!sec.url ? (
                <a className={`${s.cardCategoryItem} ${s.disableClick}`}>
                  {`${sec.name} `}
                </a>
              ) : sec.type === 'taxonomy' &&
              tpPageName === 'taxonomyListing' ? (
                <a
                  className={`${s.cardCategoryItem} ${s.disableClick} ${
                    s.taxonomySubTopic
                  }`}
                >
                  {`${sec.name} `}
                </a>
              ) : (
                <Link
                  className={s.cardCategoryItem}
                  onClick={e => {
                    e.stopPropagation();
                    gaOnLabelClick(sec);
                  }}
                  key={`${sec.name}_${i}`}
                  to={sec.url}
                >
                  {sec.name}
                </Link>
              )),
          )}
      </div>
    );
  };

  const getTOIPTimeStamp = () => (
    <ul className={s.toiptimestamp}>
      {Array.isArray(data?.authors) &&
        data?.authors.length > 0 && (
          <li className={s.authors}>
            {data.authors.map(
              author =>
                tpPageName === author.name ? (
                  <a className={`${s.authorItem} ${s.disableClick}`}>
                    {author.name}
                  </a>
                ) : (
                  <Link
                    className={s.authorItem}
                    key={author.id}
                    to={author.url}
                    onClick={e => {
                      e.stopPropagation();
                      toiPlusGAEvent(
                        `TOIPlus_${author.name}_${author.id}_click`,
                      );
                    }}
                  >
                    {author.name}
                  </Link>
                ),
            )}
          </li>
        )}
      {data?.ag && (
        <li>
          <span>{data?.ag}</span>
        </li>
      )}
    </ul>
  );

  const getTOIPCardImage = () => (
    <Link
      to={data.wu}
      className={`${figureClassName} ${itemClass} ${figureClass} ${props.useContentVisibilty &&
        contentVisibilityClass}`}
      key={data.id}
      data-videomsid={data.id}
      data-scrollga={viewga}
      target={_target}
      onClick={() => {
        toiPlusGAEvent(`${gaPageName}_Story_${data.id}_click`);
      }}
      rel={data.rel}
    >
      {imageSrc &&
        !noImage && (
          <div
            className={`${s.cardimage} ${leadPhotostoryVideoClass} ${imgCont}`}
          >
            <div className={`${s.content} cardactive`}>
              <ImageElement
                key={data.id}
                width={imgWidth}
                src={imageSrc}
                placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
                alt={headingTxt}
                lazyload={!shouldNotlazyloadImage}
                onError={customOnError}
                offsetVertical={300}
                className={classNames({
                  [s[`fit_${imgFit}`]]: imgFit,
                })}
                addFetchPriorityHighAttribute={addFetchPriorityHighAttribute}
              />
            </div>
            {isIconNeeded &&
              !(
                isLeadImageNews ||
                isLeadTypeTwo ||
                isLeadVideo ||
                isPhotoWidget ||
                plusIconNotRequired
              ) &&
              Icon(
                isPhotoStory,
                isTypeVideo,
                showDuration && duration,
                showPhotosCount && photosCount,
                isInlineSmallIconCard,
                isMobileInlineVideo,
                isToiPlusStory,
                '',
                '',
                showPriceTag,
                priceTag,
                isTOIPLeadImage,
              )}
          </div>
        )}
    </Link>
  );

  const getTOIPCardPOPImage = () => (
    <>
      <Link
        onClick={e => {
          e.preventDefault();
          handleBannerClick(data);
        }}
      >
        <div
          className={`${s.cardimage} ${leadPhotostoryVideoClass} ${imgCont}`}
        >
          <div className={`${s.content} cardactive`}>
            <ImageElement
              key={data.id}
              width={imgWidth}
              src={imageSrc}
              placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
              alt={headingTxt}
              lazyload={!shouldNotlazyloadImage}
              onError={customOnError}
              offsetVertical={300}
              className={classNames({
                [s[`fit_${imgFit}`]]: imgFit,
              })}
              addFetchPriorityHighAttribute={addFetchPriorityHighAttribute}
            />
          </div>
          {isIconNeeded &&
            !(
              isLeadImageNews ||
              isLeadTypeTwo ||
              isLeadVideo ||
              isPhotoWidget ||
              plusIconNotRequired
            ) &&
            Icon(
              isPhotoStory,
              isTypeVideo,
              showDuration && duration,
              showPhotosCount && photosCount,
              isInlineSmallIconCard,
              isMobileInlineVideo,
              isToiPlusStory,
              '',
              '',
              showPriceTag,
              priceTag,
              isTOIPLeadImage,
            )}
        </div>
      </Link>
    </>
  );

  const getTOIPCardTitle = () => (
    <>
      {isTopWidget && !toiPCardTheme ? (
        <h1>
          <Link
            to={data.wu}
            target={_target}
            className={s.toipCaption}
            onClick={() => {
              toiPlusGAEvent(`${gaPageName}_Story_${data.id}_click`);
            }}
            dangerouslySetInnerHTML={{
              __html: headingTxt,
            }}
          />
        </h1>
      ) : (
        <h3>
          <Link
            to={data.wu}
            target={_target}
            className={s.toipCaption}
            onClick={() => {
              toiPlusGAEvent(`${gaPageName}_Story_${data.id}_click`);
            }}
            dangerouslySetInnerHTML={{
              __html: headingTxt,
            }}
          />
        </h3>
      )}
    </>
  );
  const getTOIPCardDescription = () =>
    hideDescription && (
      <p
        className={s.toipDescription}
        dangerouslySetInnerHTML={{
          __html: `${descTxt}`,
        }}
      />
    );

  const getToipRelatedStories = () => (
    <div className={s.toipRelatedStories}>
      <h3>Related Stories</h3>
      <ul>
        {data.relatedStories.map(el => (
          <li key={el.id}>
            <Link
              to={el.wu}
              onClick={() => {
                toiPlusGAEvent(`${gaPageName}_relatedStory_${el.id}_click`);
              }}
            >
              {el.hl}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );

  const captionTrimVal = props.insertCaptionPlatform === 'mobile' ? 54 : 75;

  let imagecaptn = props?.data?.imagecaptn ? props?.data?.imagecaptn : '';

  let showImageCaption = props?.data?.showImageCaption
    ? props?.data?.showImageCaption
    : '';
  const imagelist = props?.data?.imagelist;
  if (!imagecaptn && Array.isArray(imagelist) && imagelist.length === 1) {
    imagecaptn = imagelist[0]?.imagecaptn;
    showImageCaption = imagelist[0]?.showImageCaption;
  }
  showImageCaption = showImageCaption !== 'false';

  const isRelatedStoriesPresent =
    enableRelatedStoriesSupport &&
    data &&
    Array.isArray(data.relatedStories) &&
    data.relatedStories.length > 1 &&
    (isLeadImageNews || isInlineSmallIconCard);

  const nonPrimeCardFigure = (
    <>
      <figure
        style={{ backgroundColor: campaignBgColor }}
        className={`${figureClassName} ${itemClass} ${figureClass} ${props.useContentVisibilty &&
          contentVisibilityClass} ${isExplainerListingCard &&
          s.explainercard} ${campaignBgColor ? `campaignBgColor` : ``} ${
          data.relatedStories ? s.leadthumb : ''
        }`}
        key={data.id}
        data-videomsid={data.id}
        data-scrollga={viewga}
        {...(stpPrpgtnAndPrvDflt
          ? {
              'data-ua-type': '1',
              'data-sp-pd-click': 'stpPgtnAndPrvntDefault(event)',
              onClick: event => {
                window.stpPgtnAndPrvntDefault(event);
              },
            }
          : {})}
      >
        {isTypeAd ? (
          <div className={s.affStoryWrap}>
            <AdCaller data={data} />
          </div>
        ) : (
          <Link
            ref={topStoryCardRef}
            to={data.wu}
            className={`${cardInner} ${noLinkClass}`}
            onClick={onClick}
            data={linkData}
            extraClick={triggerGrxclick}
            data-newga={getGAVal(props.newga, data)}
            doNotChangeURL={props.doNotChangeURL}
            {...!isMobile && {
              onMouseEnter: () => sethoveredSlikeId(slikeId),
              onMouseLeave: () => sethoveredSlikeId(false),
            }}
            onTouchStart={() => handleTouchStart(slikeId)}
            //ga4Data={props.ga4DataNews}
            ga4Type={ga4Type}
            isNoLink={isNoLink}
            ga4Data={
              ga4Type && ga4Type === 'top_stories'
                ? [
                    {
                      event: 'user_click',
                      type: `main_line_up`,
                      label: `${
                        props.newgaLabel ? `${props.newgaLabel}_` : ''
                      }${
                        data.tn === 'video'
                          ? 'videoshow'
                          : data.tn === 'news' ? 'articleshow' : data.tn
                      }`,
                      category: `story_click`,
                      sublabel: data?.ga4SubLabel ? data.ga4SubLabel : '',
                      story_no: `${gaIndex}`,
                      msid: data?.id ? data.id : '',
                    },
                  ]
                : ga4Type &&
                  ga4Type !== 'top_stories' && [
                    {
                      event: 'user_click',
                      type: `${ga4Type}`,
                      category: `${ga4Category || 'story_click'}`,
                      story_no: `${gaIndex}`,
                      msid: data?.id ? data.id : '',
                    },
                  ]
            }
            target={_target}
            rel={data.rel}
          >
            {!(cardClass === 'cardwithoutthumb' && !isVerticalTile) &&
              imageSrc &&
              !noImage && (
                <div
                  className={`${
                    s.cardimage
                  } ${leadPhotostoryVideoClass} ${imgCont}`}
                >
                  <div className={`${s.content} cardactive`}>
                    {/* This is to show live button on imagetop in case of live story */}
                    {props.showLiveBtn && data.tn === 'liveblog' ? (
                      <div className={s.liveBtn}>Live</div>
                    ) : null}
                    {props.showNewLiveBtn &&
                    data.tn === 'liveblog' &&
                    isLeadImageNews ? (
                      <span className={s.liveIconWrapper}>
                        <LeadLiveIcon />
                      </span>
                    ) : null}
                    <ImageElement
                      key={data.id}
                      width={imgWidth}
                      src={imageSrc}
                      // placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
                      placeHolderSrc="https://static.toiimg.com/photo/83033472.cms"
                      alt={headingTxt}
                      altTitle={headingTxt}
                      lazyload={!shouldNotlazyloadImage}
                      onError={customOnError}
                      offsetVertical={300}
                      className={classNames({
                        [s[`fit_${imgFit}`]]: imgFit,
                      })}
                      addFetchPriorityHighAttribute={
                        addFetchPriorityHighAttribute
                      }
                      gaIndex={gaIndex}
                      hoveredSlikeIndex={gaIndex}
                      hoveredSlikeId={
                        isMobile ? props.hoveredSlikeId : hoveredSlikeId
                      }
                      slikeId={slikeId}
                    />
                  </div>
                  {isIconNeeded &&
                    !(
                      isLeadImageNews ||
                      isLeadTypeTwo ||
                      isLeadVideo ||
                      isPhotoWidget ||
                      plusIconNotRequired
                    ) &&
                    Icon(
                      isPhotoStory,
                      isTypeVideo,
                      showDuration && duration,
                      showPhotosCount && photosCount,
                      isInlineSmallIconCard,
                      isMobileInlineVideo,
                      isToiPlusStory,
                      isPaperStoryText,
                      payPerTxt,
                    )}
                </div>
              )}
            {isLeadImageNews ||
            isLeadTypeTwo ||
            (isLeadVideo || isPhotoWidget) ? (
              <div
                className={`${titleContainerClass} ${titleCont} ${
                  props.insertCaptionPlatform && imagecaptn && showImageCaption
                    ? s.cardWithCaption
                    : ''
                }`}
              >
                {(isLeadTypeTwo ||
                  isLeadImageNews ||
                  isLeadVideo ||
                  isPhotoWidget ||
                  plusIconNotRequired) &&
                  Icon(
                    isPhotoStory,
                    isTypeVideo,
                    duration,
                    showPhotosCount && photosCount,
                    isInlineSmallIconCard,
                    isMobileInlineVideo,
                    isToiPlusStory,
                  )}
                {titlePrefix !== 'undefined' &&
                  titlePrefix !== '' &&
                  (!(data.tn === 'photostory' || data.tn === 'video') && (
                    <span className={s.leadToiplus} />
                  ))}

                {((isExplainerListingCard && data.secname) ||
                  (showDate && data.dl)) && (
                  <div className={`${s.data_meta_lead}`}>
                    <>
                      {isExplainerListingCard &&
                        data.secname && (
                          <span className={s.metaTag}>{data.secname}</span>
                        )}
                      {showDate &&
                        data.dl && (
                          <span className={`${s.dateformat}`}>{`${
                            isExplainerListingCard && data.secname ? '/ ' : ''
                          }${data.dl}`}</span>
                        )}
                    </>
                  </div>
                )}

                <figcaption>{headingTxt}</figcaption>
                {props.insertCaptionPlatform &&
                  imagecaptn &&
                  showImageCaption && (
                    <figcaption>
                      {imagecaptn.length > captionTrimVal
                        ? `${imagecaptn.substr(0, captionTrimVal - 3)}...`
                        : imagecaptn}
                    </figcaption>
                  )}
                {timeStampHtml && <p>{timeStampHtml}</p>}
                {shouldShowDescription && <p>{descTxt}</p>}
              </div>
            ) : (
              [
                isInlineSmallIconCard &&
                showDescription &&
                isMoreStoriesListingCard ? (
                  <div className={s.cardText}>
                    {renderConditionalCard(campaignTxtColor)}
                  </div>
                ) : (
                  [
                    isInlineSmallIconCard && isMoreStoriesListingCard
                      ? renderMoreStoriesCard()
                      : renderConditionalCard(campaignTxtColor),
                  ]
                ),
              ]
            )}
          </Link>
        )}
        {timesassistCard &&
          data.ctaText && (
            <Link
              className="timesassistCaption"
              to={data.wu}
              onClick={onClick}
              data={linkData}
              data-newga={getGAVal(props.newga, data)}
              doNotChangeURL={props.doNotChangeURL}
              ga4Data={props.ga4DataNews}
              target={_target}
              rel={data.rel}
            >
              {data.ctaText}
              {data.toiPlusLogo && <i className="timesAssistPlusIcon" />}
            </Link>
          )}
        {data &&
          data.secdetail &&
          (data.secdetail.displayTime ||
            (data.secdetail.hl && data.secdetail.wu)) && (
            <CardBottom secdetail={data.secdetail} ga4Type={props.ga4Type} />
          )}
      </figure>
      {isRelatedStoriesPresent && (
        <RelatedStoriesCardBottom
          data={data}
          isCtnCpd={isCtnCpd}
          isLeadImageNews={isLeadImageNews}
        />
      )}
      {isExplainerListingCard &&
        shouldShowBottomDescription && (
          <div className={s.bottomDesc}>
            <p>{descTxt}</p>
          </div>
        )}
    </>
  );

  const wrappedNonPrimeCardFigure = isRelatedStoriesPresent ? (
    <div
      className={`${s.relatedStoriesCardContainer} ${
        isLeadImageNews ? 'relatedLeadNews' : ''
      }`}
    >
      {nonPrimeCardFigure}
    </div>
  ) : (
    nonPrimeCardFigure
  );
  return (
    <>
      {bannerPopup &&
        showBannerPopup &&
        bannerPopup?.imageid &&
        renderPopupImage()}

      {!istoipListing && (
        <>{showPopup ? getTOIPCardPOPImage() : wrappedNonPrimeCardFigure}</>
      )}
      {istoipListing && (
        <div
          className={`${s.toipCard} ${data.isLead ? s.featured : ''} ${
            isMostAnalytics ? s.mostAnalytics : ''
          } ${index === 1 && !data.isLead ? s.borderBottomNone : ''}`}
        >
          {toiPCardTheme ? (
            <div
              className={`${cardInner} ${isVertical ? s.isVertical : ''} ${
                isTopWidget ? s.topWidget : ''
              } ${isHomeListing ? s.homeListing : ''} ${
                isLongCard ? s.longCard : ''
              } ${toiPCardTheme ? s.toiPCardTheme : ''}`}
              data={linkData}
              data-newga={getGAVal(props.newga, data)}
              // doNotChangeURL={props.doNotChangeURL} // // was showing error t.y. removing this
            >
              {showSectionName !== '' ? toipCardCategory() : null}
              {getTOIPCardTitle()}
              <div className={s.themeCardWrapper}>
                {getTOIPCardImage()}
                <div className={s.toipCardDetails}>
                  {!showRelatedStories &&
                    shouldShowDescription &&
                    getTOIPCardDescription()}
                  {timeStampHtml && getTOIPTimeStamp()}
                  {showRelatedStories && getToipRelatedStories()}
                </div>
              </div>
            </div>
          ) : (
            <div
              className={`${cardInner} ${isVertical ? s.isVertical : ''} ${
                isTopWidget ? s.topWidget : ''
              } ${isHomeListing ? s.homeListing : ''} ${
                isLongCard ? s.longCard : ''
              }`}
              data={linkData}
              data-newga={getGAVal(props.newga, data)}
              // doNotChangeURL={props.doNotChangeURL}  // was showing error t.y. removing this
            >
              {getTOIPCardImage()}
              {isWapView ? (
                <>
                  <div className={s.toipCardDetails}>
                    {showSectionName !== '' ? toipCardCategory() : null}
                    {getTOIPCardTitle()}
                    {!showRelatedStories &&
                      shouldShowDescription &&
                      getTOIPCardDescription()}
                  </div>
                  {timeStampHtml && getTOIPTimeStamp()}
                  {showRelatedStories && getToipRelatedStories()}
                </>
              ) : (
                <div className={s.toipCardDetails}>
                  {showSectionName !== '' ? toipCardCategory() : null}
                  {getTOIPCardTitle()}
                  {!showRelatedStories &&
                    shouldShowDescription &&
                    getTOIPCardDescription()}
                  {timeStampHtml && getTOIPTimeStamp()}
                  {showRelatedStories && getToipRelatedStories()}
                </div>
              )}
            </div>
          )}
          {/* {isLeadImageNews ||
              isLeadTypeTwo ||
              (isLeadVideo || isPhotoWidget) ? (
                <div className={`${titleContainerClass} ${titleCont}`}>
                  {(isLeadTypeTwo ||
                    isLeadImageNews ||
                    isLeadVideo ||
                    isPhotoWidget ||
                    plusIconNotRequired) &&
                    Icon(
                      isPhotoStory,
                      isTypeVideo,
                      duration,
                      showPhotosCount && photosCount,
                      isInlineSmallIconCard,
                      isMobileInlineVideo,
                      isToiPlusStory,
                    )}
                  {titlePrefix !== 'undefined' &&
                    titlePrefix !== '' &&
                    (!(data.tn === 'photostory' || data.tn === 'video') && (
                      <span className={s.leadToiplus} />
                    ))}
                </div>
              ) : (
                [
                  isInlineSmallIconCard &&
                  showDescription &&
                  isMoreStoriesListingCard ? (
                    <div className={s.cardText}>{renderConditionalCard()}</div>
                  ) : (
                    [
                      isInlineSmallIconCard && isMoreStoriesListingCard
                        ? renderMoreStoriesCard()
                        : renderConditionalCard(),
                    ]
                  ),
                ]
              )} */}
        </div>
      )}
    </>
  );
}
const mapStateToProps = (state, props) => ({
  isMobile: state.isMobile,
  imgWidth: props.imgWidth || (state.isMobile ? '375' : '600'),
});
Card.propTypes = {
  // mediatype: PropTypes.string,
  // description: PropTypes.string,
  data: PropTypes.shape({}).isRequired,
  isLeadImageNews: PropTypes.bool,
  isLeadTypeTwo: PropTypes.bool,
  //isLeadTypeThree: PropTypes.bool,
  isLeadVideo: PropTypes.bool,
  showSectionName: PropTypes.bool,
  //videoWidget: PropTypes.bool,
  onClick: PropTypes.func,
  isLeadPhoto: PropTypes.bool,
  isMobileInlineVideo: PropTypes.bool,
  isInlineSmallIconCard: PropTypes.bool,
  isVerticalTile: PropTypes.bool,
  isPhotoWidget: PropTypes.bool,
  isVideoWidget: PropTypes.bool,
  itemClass: PropTypes.string,
  showDescription: PropTypes.bool,
  showLiveBtn: PropTypes.bool,
  linkData: PropTypes.shape({}),
  newga: PropTypes.string,
  htmlKeys: PropTypes.arrayOf(PropTypes.string),
  shouldNotlazyloadImage: PropTypes.bool,
  imgFit: PropTypes.string,
  imgWidth: PropTypes.string,
  cssObj: PropTypes.shape({}),
  timeStampHtml: PropTypes.string,
  plusIconNotRequired: PropTypes.bool,
  doNotChangeURL: PropTypes.bool,
  target: PropTypes.bool,
  showDuration: PropTypes.bool,
  showPhotosCount: PropTypes.bool,
  isPhotoVisualStory: PropTypes.bool,
  viewga: PropTypes.string,
  useContentVisibilty: PropTypes.bool,
  isMoreStoriesListingCard: PropTypes.bool,
  topicPage: PropTypes.bool,
  restProps: PropTypes.shape({}),
  cardClass: PropTypes.bool,
  istoipListing: PropTypes.bool,
  isWapView: PropTypes.bool,
  gaPageName: PropTypes.string,
  userData: PropTypes.shape({
    isLoggedIn: PropTypes.bool,
    prcValue: PropTypes.number,
  }),
  tpPageName: PropTypes.string,
  isVertical: PropTypes.bool,
  toiPCardTheme: PropTypes.bool,
  priceTag: PropTypes.string,
  paidStoriesMsid: PropTypes.arrayOf(PropTypes.string),
  isPaperStoryText: PropTypes.bool,
  payPerTxt: PropTypes.string,
  index: PropTypes.number,
  hideDescription: PropTypes.bool,
  insertCaptionPlatform: PropTypes.string,
  isExplainerListingCard: PropTypes.bool,
  showBottomDescription: PropTypes.bool,
  showCategory: PropTypes.bool,
  topicNewsPage: PropTypes.bool,
  hideInnerIntrinsicSize: PropTypes.bool,
  showDate: PropTypes.bool,
  useImageV2: PropTypes.bool,
  isMobile: PropTypes.bool,
  timesassistCard: PropTypes.bool,
  timesassistLeadCard: PropTypes.bool,
  gaIndex: PropTypes.string,
  ga4Category: PropTypes.string,
  ga4Type: PropTypes.string,
  sportsImagewidth: PropTypes.bool,
  enableRelatedStoriesSupport: PropTypes.bool,
  isCtnCpd: PropTypes.bool,
  isNoLink: PropTypes.bool,
  noLinkClass: PropTypes.string,
  addFetchPriorityHighAttribute: PropTypes.bool,
  useLinkV2: PropTypes.bool,
  stpPrpgtnAndPrvDflt: PropTypes.bool,
};
Card.defaultProps = {
  // mediatype: undefined,
  // description: undefined,
  isLeadImageNews: false,
  isLeadTypeTwo: false,
  plusIconNotRequired: false,
  //isLeadTypeThree: false,
  isLeadVideo: false,
  showSectionName: false,
  //videoWidget: false,
  isLeadPhoto: false,
  onClick: undefined,
  isMobileInlineVideo: false,
  isInlineSmallIconCard: false,
  isVerticalTile: false,
  isPhotoWidget: false,
  isVideoWidget: false,
  itemClass: '',
  showDescription: false,
  showLiveBtn: false,
  linkData: undefined,
  newga: '',
  htmlKeys: [],
  shouldNotlazyloadImage: false,
  imgFit: undefined,
  imgWidth: '',
  cssObj: {},
  timeStampHtml: null,
  doNotChangeURL: false,
  target: false,
  showDuration: true,
  showPhotosCount: true,
  isPhotoVisualStory: false,
  viewga: '',
  useContentVisibilty: false,
  isMoreStoriesListingCard: false,
  topicPage: false,
  restProps: {},
  cardClass: false,
  istoipListing: false,
  isWapView: false,
  gaPageName: '',
  tpPageName: '',
  isVertical: false,
  userData: undefined,
  toiPCardTheme: false,
  priceTag: '',
  paidStoriesMsid: [],
  isPaperStoryText: false,
  payPerTxt: '',
  index: null,
  hideDescription: true,
  insertCaptionPlatform: '',
  isExplainerListingCard: false,
  showBottomDescription: false,
  showCategory: false,
  topicNewsPage: false,
  hideInnerIntrinsicSize: false,
  showDate: false,
  useImageV2: false,
  isMobile: false,
  timesassistCard: false,
  timesassistLeadCard: false,
  gaIndex: '',
  ga4Category: '',
  ga4Type: '',
  sportsImagewidth: false,
  enableRelatedStoriesSupport: false,
  isNoLink: false,
  noLinkClass: '',
  addFetchPriorityHighAttribute: false,
  useLinkV2: false,
  isCtnCpd: false,
  stpPrpgtnAndPrvDflt: false,
};

export default connect(mapStateToProps)(React.memo(Card));
